export default function LegalPage({ title, children }) {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
      <h1 className="text-3xl font-bold text-slate-900">{title}</h1>
      <div className="mt-8 space-y-4 text-slate-600 leading-relaxed">{children}</div>
    </div>
  );
}
